import { render, staticRenderFns } from "./HeadArrowUpIcon.vue?vue&type=template&id=20284bec"
import script from "./HeadArrowUpIcon.vue?vue&type=script&lang=ts"
export * from "./HeadArrowUpIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports